<template>
  <Modal
    :id="'cmp-booking-reports-venue_selection_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $dft.snakeCaseToWords("venue") }}</template>

    <template slot="body">
      <div class="body-container">
        <SearchList
          :id="'list'"
          :items="list"
          :keyProperty="'booking_location_id'"
          :label="'search'"
          :selectionNumber="'single'"
          @searched="onVenueSearched"
        >
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row" @click="e => onVenueSelected(item)">
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.venue_name }}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.city }}</span>
              </dt>
            </tr>
          </template>
        </SearchList>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { BookingService } from "../../services/booking-service";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      searchString: "",
      selectedVenue: {},
      venueSearchString: "",
      venueList: []
    };
  },
  mounted: async function() {
    const res = await BookingService.getBookingReportVenues();
    this.venueList = res.data.locationlist;
  },
  computed: {
    list: function() {
      return this.venueList.map(item => {
        return {
          ...item,
          venue_name: item.booking_location_name
        };
      });
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onVenueSelected: function(selectedVenue) {
      this.selectedVenue = selectedVenue;
      this.$emit("set_venue", selectedVenue);
    },

    onVenueSearched: async function(searchString) {
      if (searchString.length != "") {
        this.venueSearchString = searchString;
        const res = await BookingService.getBookingReportVenueSearch(
          searchString
        );
        this.venueList = res.data?.locationlist;
      } else if (searchString.length == "") {
        this.venueSearchString = searchString;
        const res = await BookingService.getBookingReportVenues();
        this.venueList = res.data.locationlist;
      }
    }
  }
};
</script>
<style lang="scss">
.cmp-booking-reports-venue_selection_modal {
  .item-search {
    padding-bottom: 15px !important;
  }
}
</style>